import { StatisticalAnalysisSidebarItemCombo } from '@/modules/statistical-analysis-module/shared/components/statistical-analysis-sidebar/statistical-analysis-sidebar.models'
import { StatiscalAnalysisTypeCases } from '@/modules/statistical-analysis-module/shared/models/shared.model'
import { Nullable } from '@/shared/types/app.types'

export enum StatisticalAnalysisSearchBySidebarEventEnum {
    SEARCH_BY_ENTITY_CHANGE = 'searchBySidebarOnChangeEntity'
}

export interface StatisticalAnalysisSearchBySidebarComboItemCombo {
    id: StatiscalAnalysisTypeCases,
    text: string
}

export interface StatisticalAnalysisSearchBySidebarCombo {
    list: StatisticalAnalysisSidebarItemCombo[]
}

export interface StatisticalAnalysisSearchBySidebarComboSimple extends StatisticalAnalysisSearchBySidebarCombo{
    selection: Nullable<StatisticalAnalysisSidebarItemCombo | StatisticalAnalysisSidebarItemCombo[]>
}

export interface StatisticalAnalysisSearchBySidebarComboMultiple extends StatisticalAnalysisSearchBySidebarCombo{
    selection: Nullable<StatisticalAnalysisSidebarItemCombo[]>
}

export interface StatisticalAnalysisSidebarSearchByModel {
    typeSearch: StatisticalAnalysisSidebarItemCombo | StatisticalAnalysisSidebarItemCombo[]
    states?: StatisticalAnalysisSidebarItemCombo[]
    typeIds?: StatisticalAnalysisSidebarItemCombo[]
}

export interface StatisticalAnalysisSidebarSearchByState {
    typeSearch: StatisticalAnalysisSearchBySidebarComboSimple
    states: StatisticalAnalysisSearchBySidebarComboMultiple,
    entityTypes: StatisticalAnalysisSearchBySidebarComboMultiple
}
export const initialStatisticalAnalysisSidebarSearchByState =
    (): StatisticalAnalysisSidebarSearchByState => ({
        typeSearch: {
            list: [],
            selection: null
        },
        states: {
            list: [],
            selection: []
        },
        entityTypes: {
            list: [],
            selection: []
        }
    })
